import React from 'react';
import styles from './BookingsBar.module.css';
import { Tooltip } from 'antd';
import { ImPower } from "react-icons/im";


const BookingsBar = ({ timeFormatAmPm, charger, selectedChargerFeedBack, isSelected, haveCharger, nightChargeAvailableConnectorIDs }) => {
  const { bookings, bookingFilterTime } = charger;
  console.log("connector data in bookigs bar: ", charger._id)

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const currentDate = new Date();
    const dateToConvert = new Date(dateString);

    date.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: timeFormatAmPm
    };

    let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);

    if (date.getTime() > currentDate.getTime()) {
      updatedFormat = updatedFormat + (' (+1)');
    }

    return updatedFormat;
  }



  const startTime = new Date(bookingFilterTime.from).getTime();
  const endTime = new Date(bookingFilterTime.to).getTime();
  const total = endTime - startTime;

  let appendedArray = [];

  bookings.forEach((booking) => {
    const bookingStartTime = new Date(booking.startTime).getTime();
    const bookingEndTime = new Date(booking.endTime).getTime();

    let bookingStartPercentage = ((bookingStartTime - startTime) / total) * 100;
    let bookingEndPercentage = ((bookingEndTime - startTime) / total) * 100;

    // Clamp values between 0 and 100
    bookingStartPercentage = Math.max(0, Math.min(bookingStartPercentage, 100));
    bookingEndPercentage = Math.max(0, Math.min(bookingEndPercentage, 100));
    appendedArray.push({ start: bookingStartPercentage, end: bookingEndPercentage, type: 'utilized', time: { start: (booking.startTime), end: (booking.endTime) } });
  });

  // Fill the gaps with "unutilized" slots in a new array
  let newArray = [];
  let previousEnd = 0;
  let previousTimeEnd = new Date(bookingFilterTime.from);
  appendedArray.forEach((booking) => {
    if (booking.start > previousEnd) {
      // Fill the gap with an "unutilized" slot
      const unutilizedTime = { start: (previousTimeEnd), end: (booking.time.start) };
      newArray.push({ start: previousEnd, end: booking.start, type: 'unutilized', time: unutilizedTime });
    }
    // Add the utilized slot
    newArray.push(booking);
    previousEnd = booking.end;
    previousTimeEnd = booking.time.end
  });

  // Check for any gaps after the last booking
  if (appendedArray.length > 0 && previousEnd < 100) {
    const unutilizedTime = { start: (previousTimeEnd), end: (new Date(bookingFilterTime.to)) };
    newArray.push({ start: previousEnd, end: 100, type: 'unutilized', time: unutilizedTime });
  }

  let haveReqMin = false;
  const minDuration = 30;
  if (newArray.length) {
    if (newArray.some(booking => {
      const timeDiff = (new Date(booking.time.end) - new Date(booking.time.start)) / (1000 * 60);
      return timeDiff > minDuration && booking.type === 'unutilized';
    })) {
      haveReqMin = true;
    }
  }
  else {
    const timeDiff = (new Date(bookingFilterTime?.to) - new Date(bookingFilterTime?.from)) / (1000 * 60);
    if (timeDiff > minDuration) {
      haveReqMin = true;
    }
  }

  if ((newArray?.length == 1 && newArray[0]?.type === 'utilized') || (!haveReqMin)) {
    console.log("connector id in return null", charger._id)
    return null;
  }

  haveCharger && haveCharger();

  return (
    <>
    {/* <p>{charger._id}</p> */}
    <div className={`${styles['charger-block']} ${isSelected ? styles['selected-charger'] : ''}`}>
      
      <div className={styles['charger-properties']}>
        <div className={styles['charger-title']}>
          {/* <ImPower /> */}
          <b>{charger.charger.chargerTag} {charger.noOfConnectorsInCharger !== 1 ? ` - #${charger.connectorNumber}` : ""} {` (${charger.type}) `}</b>  {nightChargeAvailableConnectorIDs.includes(charger._id) ? " - OverNight" : ""} </div>
        {/* <div className={styles['charger-title']}><b>Level 2</b></div> */}
      </div>

      <div className={styles['progress-start-end']}>
        <span>{formatDate(bookingFilterTime.from)} (Today)</span>
        <span>{formatDate(bookingFilterTime.to)}</span>
      </div>
      <div className={`progress ${styles['progress']}`} >
        {
          newArray.length ? newArray.map((booking, index) => (
            <Tooltip
              color={booking.type === 'unutilized' ? '#50b965' : 'gray'}
              placement="top"
              title={`${booking.type.charAt(0).toUpperCase() + booking.type.slice(1)} ${formatDate(new Date(booking.time.start))} - ${formatDate(booking.time.end)}`} key={index}
            >
              <div
                className={`progress-bar ${styles['progressbar-' + booking.type]}`}
                role="progressbar"
                style={{ width: ((booking.end - booking.start)) + '%' }}
                aria-valuenow={((booking.end - booking.start))}
                aria-valuemin="0"
                aria-valuemax="100"
                onClick={() => { booking.type === 'unutilized' && selectedChargerFeedBack(new Date(booking.time.start), new Date(booking.time.end), charger) }}
              >
              </div>
            </Tooltip>
          )) :

            (
              <Tooltip
                color={'#50b965'}
                placement="top"
                title={`${'Unutilized'} ${formatDate(new Date(bookingFilterTime.from))} - ${formatDate(new Date(bookingFilterTime.to))}`}
              >
                <div
                  className={`progress-bar ${styles['progressbar-unutilized']}`}
                  role="progressbar"
                  style={{ width: '100%' }}
                  aria-valuenow={((100))}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  onClick={() => { selectedChargerFeedBack(new Date(bookingFilterTime.from), new Date(bookingFilterTime.to), charger) }}
                >
                </div>
              </Tooltip>

            )
        }
      </div>
    </div>
    </>
  );
};

export default BookingsBar;
